<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card
          title="جزئیات پروژه"
        >
          <b-form
            ref="projectform"
            @submit.prevent
          >
            <b-row>

              <b-col
                class="mt-2 form-size"
                md="6"
                offset-md="3"
              >
                <b-row>

                  <b-col
                    class="image"
                    cols="12"
                  >
                    <b-media class="mb-2">
                      <template #aside>
                        <b-avatar
                          ref="previewEl"
                          :src="Form.Image"
                          size="90px"
                          rounded
                          button
                          @click="$refs.refInputEl.click()"
                        />
                      </template>
                      <input
                        :ref="'refInputEl'"
                        type="file"
                        class="d-none"
                        name="Image"
                        @input="imageRenderer($event)"
                      >
                      <b-row>
                        <b-col md="12">
                          <b-form-group
                            label="عنوان"
                            label-for="Title"
                            class="mb-0"
                          >
                            <b-form-input
                              id="Title"
                              v-model="Form.Title"
                              name="Title"
                              autocomplete="off"
                            />
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-media>
                  </b-col>

                  <b-col md="12">
                    <b-form-group
                      label="پیوند یکتا"
                      label-for="Slug"
                    >
                      <b-form-input
                        id="Sort"
                        v-model="Form.Slug"
                        name="Slug"
                        autocomplete="off"
                        dir="ltr"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                      label="وضعیت"
                      label-for="Visibility"
                    >
                      <v-select
                        v-model="Form.Visibility"
                        :options="enums('IsActive')"
                        dir="rtl"
                        label="text"
                        name="Visibility"
                        :clearable="false"
                        :reduce="x => x.value"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="8">
                    <b-form-group
                      label="دسته بندی"
                      label-for="BlogCategoryId"
                    >
                      <project-category
                        v-model="Form.ProjectCategoryId"
                        :multiple="false"
                        :clearable="false"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group
                      label="تگ ها"
                      label-for="Tag"
                    >
                      <b-form-tags
                        v-model="Form.Tag"
                        name="Tag"
                        placeholder=""
                        add-button-text="افزودن"
                        add-button-variant="outline-primary"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="12">
                    <b-form-group
                      label="توضیحات"
                      label-for="Description"
                    >
                      <z-quill-editor v-model="Form.Description" />
                    </b-form-group>

                  </b-col>

                  <z-seo v-model="Form" />

                  <b-col cols="12">
                    <div class="divider divider-solid">
                      <div
                        class="divider-text"
                        style="font-weight: 600;"
                      >
                        مشخصات
                      </div>
                    </div>
                  </b-col>

                  <b-col cols="12">
                    <b-row
                      v-for="(item, index) in Form.ProjectSpecification"
                      :key="index"
                    >

                      <b-col md="5">
                        <b-form-group
                          label="عنوان"
                          :label-for="'Title'[index]"
                        >
                          <b-form-input
                            v-model="item.Title"
                            autocomplete="off"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col md="5">
                        <b-form-group
                          label="توضیحات"
                          :label-for="'Description'[index]"
                        >
                          <b-form-input
                            v-model="item.Description"
                            autocomplete="off"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col
                        md="2"
                        class="mb-1"
                        style="display: flex; align-items: flex-end;"
                      >
                        <template v-if="ProjectSpecificationRemoveId !== index">
                          <b-button
                            v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                            variant="outline-danger"
                            class="btn-icon rounded-circle"
                            @click="removeProjectSpecification(index)"
                          >
                            <feather-icon
                              icon="TrashIcon"
                            />
                          </b-button>
                        </template>
                        <template v-else>
                          <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            class="btn-icon rounded-circle"
                            variant="outline-primary"
                            @click="cancelProjectSpecification"
                          >
                            <feather-icon icon="XIcon" />
                          </b-button>
                          <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            class="btn-icon rounded-circle ml-1"
                            variant="outline-primary"
                            @click="confirmProjectSpecification"
                          >
                            <feather-icon icon="CheckIcon" />
                          </b-button>
                        </template>
                      </b-col>

                    </b-row>
                  </b-col>

                  <b-col class="mt-50">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="gradient-info"
                      @click="addProjectSpecification"
                    >
                      <feather-icon
                        icon="PlusIcon"
                        class="mr-25"
                      />
                      <span>افزودن</span>
                    </b-button>
                  </b-col>

                  <b-col cols="12">
                    <div class="divider divider-solid">
                      <div
                        class="divider-text"
                        style="font-weight: 600;"
                      >
                        گالری
                      </div>
                    </div>
                  </b-col>
                  <div
                    v-for="(item, index) in Form.ProjectGallery"
                    :key="item.Id"
                    class="px-1 mb-1"
                  >
                    <b-avatar
                      ref="previewEl"
                      :src="item.Url"
                      size="120px"
                      rounded
                      class="foodrecipes-image mt-1"
                    />
                    <b-form-group style="width: 120px;">
                      <b-form-input
                        v-model="item.Title"
                        autocomplete="off"
                        class="mt-1"
                        @click="showModal(item)"
                      />
                    </b-form-group>
                    <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      style=""
                      class="btn-icon video-remove"
                      @click="removeGallery(item)"
                    >
                      <feather-icon
                        icon="XIcon"
                        size="14"
                      />
                    </b-button>
                  </div>

                  <input
                    ref="refGalley"
                    type="file"
                    class="d-none"
                    accept="image/*"
                    @change="galleryRenderer($event)"
                  >

                  <div class="px-1 mb-1 mt-1">
                    <div
                      class="activity-upload-video"
                      @click="$refs.refGalley.click()"
                    >
                      <div class="activity-upload-video-icon">
                        <feather-icon
                          size="24"
                          icon="UploadIcon"
                        />
                      </div>
                    </div>
                  </div>

                  <b-col cols="12">
                    <hr>
                  </b-col>
                  <b-col class="mt-1 mb-2 text-center">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="primary"
                      class="mr-1"
                      @click="save"
                    >
                      ذخیره
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      @click="back"
                    >
                      بازگشت
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <b-modal
      v-if="isShowModal"
      v-model="isShowModal"
      ok-title="ذخیره"
      centered
      ok-only
      title="عنوان تصویر"
      :no-close-on-backdrop="true"
      size="sm"
      @ok="saveModal"
    >
      <b-row class="mt-1">
        <b-col md="12">
          <b-form-group>
            <b-form-input
              v-model="row.Title"
              autocomplete="off"
              autofocus
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>

  </b-overlay>
</template>

<script>

import ProjectCategory from '@/tools/projectcategory.vue'
import ZQuillEditor from '@/tools/quilleditor.vue'
import ZSeo from '@/tools/seo.vue'

export default {
  name: 'ProjectDetails',
  components: { ZSeo, ZQuillEditor, ProjectCategory },
  data() {
    return {
      Form: {
        Id: null,
        Title: null,
        Image: null,
        Description: null,
        ProjectCategoryId: null,
        Visibility: true,
        ProjectGallery: [],
        ProjectSpecification: [],
        Slug: null,
        MetaTitle: null,
        ImageAlt: null,
        MetaDescription: null,
        MetaKeywords: null,
      },
      GalleryFile: [],
      loading: false,
      galleryId: 0,
      ProjectSpecificationRemoveId: null,
      isShowModal: false,
    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    }
  },
  methods: {
    save() {
      let url = this.$api.project.add
      if (this.$route.params.id) {
        url = this.$api.project.update
      }

      const formData = new FormData(this.$refs.projectform)
      formData.append('Id', this.Form.Id)
      formData.append('Visibility', this.Form.Visibility)

      if (this.Form.Description) {
        formData.append('Description', this.Form.Description)
      }

      if (this.Form.ProjectCategoryId) {
        formData.append('ProjectCategoryId', this.Form.ProjectCategoryId)
      }
      // this.Form.ProjectCategoryId.forEach(item => {
      //     formData.append('ProjectCategoryId', item)
      // })

      this.Form.ProjectSpecification.forEach((item, index) => {
        if ((item.Title && item.Title.trim()) || (item.Description && item.Description.trim())) {
          formData.append(`ProjectSpecification[${index}].Title`, item.Title)
          formData.append(`ProjectSpecification[${index}].Description`, item.Description)
        }
      })

      this.Form.ProjectGallery.forEach((item, index) => {
        formData.append(`ProjectGallery[${index}].Id`, item.Id)
        if (item.Title) {
          formData.append(`ProjectGallery[${index}].Title`, item.Title)
        }

        formData.append(`ProjectGallery[${index}].Sort`, index)
        if (this.GalleryFile.filter(x => x.Id == item.Id)[0]) {
          formData.append(`ProjectGallery[${index}].Url`, this.GalleryFile.filter(x => x.Id == item.Id)[0].Url)
        }
      })

      this.loading = true
      this.$http.post(
        url, formData,
      )
        .then(() => {
          this.back()
        })
        .finally(() => {
          this.loading = false
        })
    },
    imageRenderer(event) {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(event.target.files[0])

      fileReader.onload = () => {
        this.Form.Image = fileReader.result
      }
    },
    galleryRenderer(event) {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(event.target.files[0])

      fileReader.onload = () => {
        this.galleryId++

        this.Form.ProjectGallery.push({ Url: fileReader.result, Id: this.galleryId })
        this.GalleryFile.push({ Url: event.target.files[0], Id: this.galleryId })
      }
    },
    removeGallery(item) {
      this.Form.ProjectGallery = this.Form.ProjectGallery.filter(x => x.Id !== item.Id)
    },
    addProjectSpecification() {
      this.Form.ProjectSpecification.push({
        Title: '', Description: '',
      })
    },
    removeProjectSpecification(index) {
      this.ProjectSpecificationRemoveId = index
    },
    confirmProjectSpecification() {
      this.Form.ProjectSpecification.splice(this.ProjectSpecificationRemoveId, 1)
      this.ProjectSpecificationRemoveId = null
    },
    cancelProjectSpecification() {
      this.ProjectSpecificationRemoveId = null
    },
    get() {
      this.loading = true
      this.$http.post(
        this.$api.project.get, {
          Id: this.Form.Id,
        },
      )
        .then(res => {
          this.loading = false
          this.Form = res.data
        })
    },
    showModal(row) {
      this.isShowModal = true
      this.row = row
    },
    saveModal() {
      this.isShowModal = false
    },
  },
}
</script>

<style scoped>
.image .media-body {
    align-self: flex-end;
}
</style>
